import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Embed from "./pages/Embed";
import EmbedDocs from "./pages/EmbedDocs";
import CSCE from "./pages/CSCE";
import CSCEEmbed from "./pages/CSCEEmbed";
import CSCEEmbedDocs from "./pages/CSCEEmbedDocs";
import CSP from "./pages/CSP";
import CSL from "./pages/CSL";
import CCSP from "./pages/CCSP";
import CSPEmbed from "./pages/CSPEmbed";
import CSPEmbedDocs from "./pages/CSPEmbedDocs";
import CSLEmbed from "./pages/CSLEmbed";
import CSLEmbedDocs from "./pages/CSLEmbedDocs";
import CCSPEmbed from "./pages/CCSPEmbed";
import CCSPEmbedDocs from "./pages/CCSPEmbedDocs";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <HashRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/embed" element={<Embed />} />
          <Route path="/embed-docs" element={<EmbedDocs />} />
          <Route path="/csce" element={<CSCE />} />
          <Route path="/csce-embed" element={<CSCEEmbed />} />
          <Route path="/csce-embed-docs" element={<CSCEEmbedDocs />} />
          <Route path="/csp" element={<CSP />} />
          <Route path="/csl" element={<CSL />} />
          <Route path="/ccsp" element={<CCSP />} />
          <Route path="/csp-embed" element={<CSPEmbed />} />
          <Route path="/csp-embed-docs" element={<CSPEmbedDocs />} />
          <Route path="/csl-embed" element={<CSLEmbed />} />
          <Route path="/csl-embed-docs" element={<CSLEmbedDocs />} />
          <Route path="/ccsp-embed" element={<CCSPEmbed />} />
          <Route path="/ccsp-embed-docs" element={<CCSPEmbedDocs />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </HashRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;